/**
 * Description of file.
 * @author: adalto.junior
 * Date: 07/01/14
 * Time: 17:41
 */


Greenmile.GroupPermissions = Greenmile.GroupPermissions || {};

Greenmile.GroupPermissions.Utils = {

    updateNodesPermissions: function (listPermissions) {

        var modules = Monet.Session.GroupPermission.nodes;
        var modulesLength = modules.length;
        var permissionsNew = listPermissions.permissions;

        var isContained = function (permissionId) {

            var permissionNewLength = permissionsNew.length;

            for (var l = 0; l < permissionNewLength; l++) {

                var permissionNew = permissionsNew[l];

                if (permissionNew.id === permissionId) {
                    return true;
                }

            }

        };

        for (var i = 0; i < modulesLength; i++) {

            var userInterfaces = modules[i]['userInterfaces'];
            var userInterfacesLength = userInterfaces.length;

            for (var j = 0; j < userInterfacesLength; j++) {

                var permissions = userInterfaces[j].permissions;
                var permissionsLength = permissions.length;

                for (var k = 0; k < permissionsLength; k++) {

                    var permission = permissions[k];
                    var permissionNewLength = permissionsNew.length;

                    if (permissionNewLength) {

                        if (isContained(permission.id)) {
                            permission.active = true;
                        } else {
                            permission.active = false;
                        }

                    } else {
                        permission.active = false;
                    }

                }

            }

        }

    },

    getStatusPreviousNodeById: function (permissionId) {

        var nodesPrevious = Monet.Session.GroupPermission.nodes;
        var nodesPreviousLength = nodesPrevious.length;

        for (var k = 0; k < nodesPreviousLength; k++) {

            var userInterfaces = nodesPrevious[k].userInterfaces;

            for (var l = 0; l < userInterfaces.length; l++) {

                var permissions = userInterfaces[l].permissions;
                var permissionsLength = permissions.length;

                for (var m = 0; m < permissionsLength; m++) {

                    var permission = permissions[m];

                    if (permission.id === parseInt(permissionId, 10)) {

                        return permission.active;

                    }
                }

            }
        }

    }

};

